import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { ResultOverlay } from '../components/ResultOverlay';

const LOGO_URL = "https://i.goopics.net/rlg7li.png";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [overlay, setOverlay] = useState({ show: false, type: 'success', title: '', subtitle: '' });
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error('6 caractères minimum'); return; }
    if (password !== confirm) { toast.error('Les mots de passe ne correspondent pas'); return; }
    try {
      await api.post('/auth/reset-password', { token, password });
      setOverlay({ show: true, type: 'success', title: 'Mot de passe modifié !', subtitle: 'Vous pouvez maintenant vous connecter' });
      setDone(true);
    } catch (err) {
      setOverlay({ show: true, type: 'error', title: 'Erreur', subtitle: err.response?.data?.detail || 'Lien invalide ou expiré' });
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <ResultOverlay {...overlay} onClose={() => setOverlay(p => ({ ...p, show: false }))} />
      <div className="w-full max-w-sm">
        <div className="text-center mb-8 slide-up">
          <Link to="/"><img src={LOGO_URL} alt="RSX" className="w-16 h-16 rounded-full mx-auto mb-4" /></Link>
          <h1 className="text-2xl font-light tracking-tight" style={{ fontFamily: 'Outfit' }}>{"Nouveau mot de passe"}</h1>
        </div>

        {done ? (
          <div className="text-center slide-up">
            <CheckCircle className="w-16 h-16 text-[#10B981] mx-auto mb-4" />
            <p className="text-[#A1A1AA] mb-6">{"Votre mot de passe a été réinitialisé avec succès."}</p>
            <Link to="/login">
              <Button className="bg-[#D4AF37] text-black hover:bg-[#F9E5C0] rounded-full px-8" data-testid="back-login">Se connecter</Button>
            </Link>
          </div>
        ) : !token ? (
          <div className="text-center text-[#A1A1AA]">
            <p>Lien invalide. <Link to="/login" className="text-[#D4AF37]">Retour à la connexion</Link></p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4 slide-up stagger-1">
            <div>
              <Label className="text-xs text-[#A1A1AA] mb-1.5 block">Nouveau mot de passe</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A1A1AA]" />
                <Input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                  data-testid="reset-password" placeholder="6 caractères min."
                  className="pl-10 bg-[#121212] border-white/10 focus:border-[#D4AF37] h-11 rounded-xl text-sm" />
              </div>
            </div>
            <div>
              <Label className="text-xs text-[#A1A1AA] mb-1.5 block">Confirmer</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A1A1AA]" />
                <Input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required
                  data-testid="reset-confirm" placeholder="Confirmer le mot de passe"
                  className="pl-10 bg-[#121212] border-white/10 focus:border-[#D4AF37] h-11 rounded-xl text-sm" />
              </div>
            </div>
            <Button type="submit" data-testid="reset-submit"
              className="w-full bg-[#D4AF37] text-black hover:bg-[#F9E5C0] rounded-full h-11 text-sm font-semibold apple-press">
              {"Réinitialiser"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
